import React, { PropsWithChildren, Suspense, SuspenseProps } from 'react';
import { isBrowser } from '../../utils';
import { Box } from '../Box';
import { IconSvg } from '../IconSvg';

interface Props {
  size?: number;
  fallback?: SuspenseProps['fallback'];
}

export function SuspensePreloader({
  size = 40,
  fallback,
  children,
  ...props
}: PropsWithChildren<Props>) {
  if (!isBrowser) {
    return <ChildrenWrapper>{children}</ChildrenWrapper>;
  }

  return (
    <Suspense
      fallback={
        fallback ?? (
          <Box margin={['auto']}>
            <IconSvg src="preloader" width={size} height={size} />
          </Box>
        )
      }
      {...props}
    >
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Suspense>
  );
}

function ChildrenWrapper({ children }: PropsWithChildren<{}>) {
  return typeof children === 'function' ? children() : children;
}

export function withSuspense<T>(Component: React.FC<T>, fallback?: SuspenseProps['fallback']) {
  return (props: T) => (
    <SuspensePreloader fallback={fallback}>
      <Component {...props} />
    </SuspensePreloader>
  );
}
